// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1___7eaa615821ca9bd6a73","cls2":"MultiPaperModal-cls2__f1fa70860576c88241c7 MultiPaperModal-cls1___7eaa615821ca9bd6a73"};